import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import FleetManagementApiService from './FleetManagementApiService'
import { SAVE_DISPOSITION_PAYMENT } from 'Store/FleetManagement/FleetDispositionPaymentSave/FleetDispositionPaymentSaveType';
import { setDispositionPaymentSaveStatus } from 'Store/FleetManagement/FleetDispositionPaymentSave/FleetDispositionPaymentSaveAction';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';
import { setSaveAdminTaskvalue } from 'Store/FleetManagement/FleetAdminTask/AdminTaskAction';

function* saveDispositionPayment(req: any): any {
    try {
        yield put(globalLoaderText("Saving Payment Details...."));

        let payloadData : IPayload= {
            apiType : apiType.FleetManagement,
            endpoint : `fleet/disposition/savepayment`, 
            apiMethod :  apiMethod.POST,
            payload : req?.paymentInfo
            
        }
        const response = yield call(
            FleetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setDispositionPaymentSaveStatus(true))
            yield put(setSaveAdminTaskvalue(response))
            yield put(globalLoaderText(""));
        } else {
            yield put(setDispositionPaymentSaveStatus(false))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(setDispositionPaymentSaveStatus(false))
        yield put(globalLoaderText(""));
    }
}

function* watchGetFleetDispositionPaymentSave() {
    yield takeEvery(SAVE_DISPOSITION_PAYMENT, saveDispositionPayment)
}

export default function* combinedSaga() {
    yield all([
        watchGetFleetDispositionPaymentSave()
    ])
}